
import { useCallback } from 'react';
import { ConsentState } from '@/components/gdpr/CookieConsent';
import { updateAnalyticsConsent } from '@/utils/tagManagerUtils';

const CONSENT_STORAGE_KEY = 'upfixe-cookie-consent';

export const useCookieConsent = () => {
  // Get the current consent state
  const getConsentState = useCallback((): ConsentState | null => {
    try {
      const storedConsent = localStorage.getItem(CONSENT_STORAGE_KEY);
      if (!storedConsent) return null;
      
      return JSON.parse(storedConsent) as ConsentState;
    } catch (e) {
      console.error('Failed to get consent state:', e);
      return null;
    }
  }, []);
  
  // Check if a specific consent type is granted
  const hasConsent = useCallback((type: keyof ConsentState): boolean => {
    const consent = getConsentState();
    if (!consent) return false;
    return consent[type];
  }, [getConsentState]);
  
  // Apply the stored analytics consent to Google Analytics.
  const updateAnalyticsConsentMode = useCallback(async () => {
    const consent = getConsentState();
    if (!consent) return;

    await updateAnalyticsConsent(consent.analytics);
  }, [getConsentState]);
  
  return {
    getConsentState,
    hasConsent,
    updateAnalyticsConsentMode
  };
};
